module.exports = __webpack_public_path__ + "static/media/view3.10b52344.jpg";